import { useEffect, useCallback } from 'react'

import { useSimplePubSubClient } from '../providers/simple-pub-sub-client-provider'

export default function useSimplePubSubMessage<T>(
  channel: string,
  onMessage?: (message: T) => void
) {
  const client = useSimplePubSubClient()

  const sendMessage = useCallback(
    (message: T) => client.publish<T>(channel, message),
    [client, channel]
  )

  // oxlint-disable-next-line consistent-return
  useEffect(() => {
    if (onMessage) {
      const subscription = client.subscribe<T>(channel, onMessage)
      return () => subscription.cancel()
    }
  }, [client, channel, onMessage])

  return sendMessage
}
